import axios from 'axios';

import {ErrorModel} from '../../models';
import {DAO_CODE} from './_daoCode';
import {URL} from '../root';

const FUNCTION_CODE = 'DELETE_CONTRACTOR_CATEGORY';

export async function deleteContractorCategory(userData: any, contractorCategoryId: number | string) {
    try {
        const response = await axios.delete(
            `${URL}/contractor-categories/${contractorCategoryId}/`,
            {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Token ${userData.userToken}`
                }
            },
        );

        return response.data;
    }
    catch (error: any) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la suppression de la catégorie sous/co-traitant',
            error: error
        });
    }
}
